import { Component, OnInit, Input, Output, EventEmitter, } from '@angular/core';
import { ProcessStagesComponent } from '../process-stages/process-stages.component';
import { MaterialConsumptionComponent } from '../material-consumption/material-consumption.component';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from '../../services/data.service';
import { APIService } from '../../api.service';
import { CommonService } from '../../services/common.service';
import { from, Subject } from 'rxjs';
import { ProductionOutputComponent } from '../production-output/production-output.component';
import { EnterExpenseComponent } from '../enter-expense/enter-expense.component';

@Component({
    selector: 'app-job-details',
    templateUrl: './job-details.component.html',
    styleUrls: ['./job-details.component.scss'],
})
export class JobDetailsComponent implements OnInit {

    public minDate: Date = new Date();

    @Input() Data: any;
    @Input() mdlRef: any;
    @Input() mdlRef2: any;
    @Input() prTypeID: number = 1;

    jobDetails: any = [];
    stagesOfProds: any = [];
    Stages: any = [];

    modalReference: any;
    costTypeList: any = [];
    id: number = 0;
    rights = {
        materialIssue: true,
        storeSelect: true,
        prdCfg: false,
        allPrd: false
    };
    frmStore = {
        id: 0,
        name: '',
    };
    executive = {
        id: 0,
        name: '',
    };
    wip = {
        no: 0,
        id: 10,
    };
    orderID: string = '';
    title: string = '';
    stores: any = [];
    items: any = [];
    productItems: any = [];
    store = {
        id: 0,
        name: '',
    };
    totalItems: number = 0;
    issueQty: number = 0;
    xnCode: string = '';
    jarvisData: any = [];
    MTbl: any = [];
    firstTime: number = 1;
    storeItems: any = [];
    getAllItems: any = [];
    jobItems: any = [];
    AllData: any = [];
    isShown: boolean = false;
    closeResult: string = '';
    isWeb: boolean = true;
    changingValue: Subject<boolean> = new Subject();
    changingHeadValue: Subject<boolean> = new Subject();
    isDateLableShow: boolean = true;
    isTGTDT: boolean = false;
    orderList: any = [];
    orderNo: any = "";
    costSum: number = 0;
    userData: any = [];
    prdRights: any = [];
    isShowDel: boolean = false;
    stageTaskDetails: any = [];
    showMtlConsExpanded: boolean = true;
    selectedUserID: number = 0;
    userList: Array<any> = [];
    users: Array<any> = [];
    agencyData: any = [];
    dbUsers: any = [];
    constructor(
        private modalService: NgbModal,
        private _Activatedroute: ActivatedRoute,
        public activeModal: NgbActiveModal,
        private appService: DataService,
        private apiService: APIService,
        private router: Router,
        private commonService: CommonService
    ) { }

    ngOnInit(): void {
        var jarvis = this.apiService.getCookie('Jarvis');
        if (jarvis) {
            this.jarvisData = JSON.parse(jarvis);
        }

        this.isWeb = this.apiService.apiCheckWeb();

        var tblM = this.apiService.getCookie('M');
        if (tblM) {
            this.MTbl = JSON.parse(tblM);
        }

        let users = this.apiService.getCookie('J');
        if (users) {
            var userID = this.jarvisData[0].UserID;
            this.userList = users ? JSON.parse(users) : [];
            this.userList = this.userList.sort((a: any, b: any) => a.Name.localeCompare(b.Name));
            this.userList.forEach((user: any) => {
                user.selected = false;
            })
        }

        this.apiService.getIDB('erp_inv', (tempItems: any) => {
            if (tempItems && tempItems.length > 0) {
                this.getAllItems = tempItems;
            } else {
                 this.apiService.fetchERPStockItems('', (res: any) => {
                     if(res && res.length > 0) {
                        this.getAllItems = res;
                     }
                 });
            }
            
            let tempData: any = this.apiService.getCookie('ERP_Cfg');
            let parseStages = JSON.parse(tempData);
            this.Stages = JSON.parse(parseStages[0].PrdJobStages);
    
            let agencyData = this.apiService.getCookie("M");
            if (agencyData) {
                this.agencyData = JSON.parse(agencyData);
            }
    
            if (parseStages.length > 0) {
                if (parseStages[0].CostTypes) {
                    let tempcostTypeList = JSON.parse(parseStages[0].CostTypes);
                    if (tempcostTypeList.length > 0) {
                        this.costTypeList = tempcostTypeList.filter((x: any) => x.IsD == false)
                        this.costTypeList = this.costTypeList.sort((a: any, b: any) => a.CNm.localeCompare(b.CNm));
                    }
                }
            }
    
            /* var orderData = this.apiService.getCookie('D');
            if (orderData) {
              this.orderList = JSON.parse(orderData);
            } */
    
            var user = this.apiService.getCookie("J");
            if (user) {
                this.userData = JSON.parse(user);
            }
    
            if (this.Data) {
                this.wip.id = this.Data;
                this.getJobDetails();
            }
    
            this.appService.stageEntered.subscribe((value: any) => {
                if (value.action == 1) {
                    this.wip.id = value.jobNo;
                    this.getJobDetails();
                    this.appService.updateStageEntered({ action: 0, jobNo: 0 });
                }
            });
    
            //update if is from project module
            // let sendData = {'prTypeID': this.prTypeID}
            let sendData = { 'prTypeID': this.prTypeID, 'costSum': this.costSum, 'jobID': 0 }
            this.appService.updateProjectData(sendData)
            if (this.prTypeID == 2) {
                this.appService.projectData.subscribe((value: any) => {
                    this.costSum = 0;
                    if (value.jobID && value.jobID == this.jobDetails[0]?.JobID) {
                        if (value.costSum) {
                            this.costSum = value.costSum;
                        }
                    }
    
                });
            }
            this.getRigths();
    
            // Calls on receiving the close modal respose in stage-task list to get the latest list of tasks for the job
            this.appService.taskEntryData.subscribe((taskEntryObj: any) => {
                if (taskEntryObj.projTaskAdded) {
                    this.appService.updateTaskEntryData({});
                    this.getJobDetails();
                }
            });
        });

    }

    //getRigths() - get all users
    getRigths() {
        for (let i = 0; i < this.userData.length; i++) {
            if (this.jarvisData[0].UserID == this.userData[i].UserID) {
                this.rights.prdCfg = this.userData[i].PrdCfg;
                this.rights.allPrd = this.userData[i].Prd;
            }
        }
    }
    costTypeListMdl(content: any, id: number) {
        this.modalReference = this.modalService.open(EnterExpenseComponent, { windowClass: 'costTypeMdl', backdrop: 'static', keyboard: false });
        this.modalReference.componentInstance.mdlRef = this.modalReference;
        this.modalReference.componentInstance.isFromCostTypeList = true;
        this.modalReference.componentInstance.jobDetails = this.jobDetails;

    }
    // openBatchMdl() - Open Batch entry modal 	
    costTypeEntryMDl(content: any, id: number) {
        if (this.costTypeList.length == 0) {
            this.apiService.successAlert("Please Configure Expense Type from Settings > Expense Types.");
            return;
        }
        else {
            this.modalReference = this.modalService.open(EnterExpenseComponent, { windowClass: 'costTypeEntryMdl', backdrop: 'static', keyboard: false });
            this.modalReference.componentInstance.mdlRef = this.modalReference;
            this.modalReference.componentInstance.isFromCostTypeEntry = true;
            this.modalReference.componentInstance.jobDetails = this.jobDetails;
        }
    }
    // openBatchMdl() - Open Batch entry modal 	
    closeCostTypeMdl() {
        this.mdlRef2.close();
    }
    //#endregion

    //#region "Function"
    getJobDetails() {
        let obj = [
            {
                JobID: this.wip.id,
            },
        ];

        let myParams = [
            {
                myUserID: this.jarvisData[0].UserID,
                myToken: this.jarvisData[0].WebToken,
                forAgencyID: this.jarvisData[0].AgencyIDs,
                myAgencyIDs: this.jarvisData[0].AgencyIDs,
                ForERPAgencyID: this.MTbl[0].ERPAgencyID,
                myLastSyncDT: null,
                isWeb: true,
                actionType: 'getPrdJobDetails',
                moduleID: 8,
                data: JSON.stringify(obj),
            },
        ];

        this.apiService.getData(
            myParams,
            this.successJobDetails.bind(this),
            this.failureResp.bind(this)
        );
    }

    successJobDetails(res: any) {
        if (res.error) {
        } else {
            if (res) {
                var reponseData = JSON.parse(res.updatePackage);
                this.AllData = reponseData;
                if (reponseData) {
                    this.firstTime = 0;
                    this.jobDetails = reponseData.Table1;
                    let userIds = this.jobDetails[0]?.UserIDs?.split(',');
                    userIds.forEach((userId: any) => {
                        const prjUser = this.userList.find((user: any) => user.UserID == userId);
                        if (prjUser) {
                            let existingUser = this.users.find((user: any) => user.UserID == prjUser.UserID);
                            if (!existingUser) {
                                prjUser.selected = true;
                                this.users.push(prjUser);
                            }
                        }
                        this.dbUsers = [...this.users];
                    });
                    if (this.jobDetails[0]?.Costs) {
                        let tempCost = JSON.parse(this.jobDetails[0]?.Costs);
                        if (tempCost.length > 0) {
                            let tempAllCostList = tempCost.filter((x: any) => x.IsD == false)
                            if (tempAllCostList.length > 0) {
                                this.costSum = tempAllCostList.reduce((accumulator: any, object: any) => {
                                    return accumulator + object.Amt;
                                }, 0);
                            }

                        }
                    }
                    this.orderNo = this.jobDetails[0]?.OrderNo ? this.jobDetails[0]?.OrderNo : '';

                    /*if(this.jobDetails[0]?.OrderID != 0){
                      let orderData = this.orderList.filter((a: any) => a.OrderID == this.jobDetails[0]?.OrderID);
                      if(orderData.length > 0) {
                        this.orderNo = orderData[0].OrderNo;
                      }
                    }*/
                    this.productItems = reponseData.Table3;
                    this.productItems.forEach((a: any) => {
                        let currItem = this.getAllItems.find((i: any) => i.ItemID == a.PID);
                        if (currItem) {
                            a.ItemName = currItem.ItemName;
                            a.DefStockRate = currItem.DefStockRate;
                            a.ItemCode = currItem.ItemCode;
                            a.TempPlanQty = a.PlanQty;
                            a.IsSelect = false;
                        }
                    });

                    let tempStage = this.jobDetails[0]?.History;
                    let tempData = JSON.parse(tempStage);
                    let temp = tempData.filter((s: any) => s.Typ == 'MVM');
                    this.stagesOfProds = temp;

                    this.stagesOfProds.forEach((o: any) => {
                        let data = this.Stages.filter((a: any) => a.SID == o.FStgID);
                        let Newdata = this.Stages.filter((a: any) => a.SID == o.TStgID);
                        if (data.length > 0) {
                            o.FStg = data[0].SNm;
                        } else {
                            o.FStg = 'Packing';
                        }

                        if (Newdata.length > 0) {
                            o.TStg = Newdata[0].SNm;
                        } else {
                            o.TStg = 'Packing';
                        }
                    });
                    this.jobItems = reponseData.Table2;
                    if (this.jobItems.length == 0) {
                        this.showMtlConsExpanded = false;
                    }
                    this.getJobItems();
                    this.markJobOk();
                    this.stageTaskDetails = reponseData.Table4 ? reponseData.Table4 : [];
                }
            }
        }
    }

    //failureResp - failure handler
    failureResp(res: any) {
        if (res.error) {
        } else {
            alert(res.message);
            //alert(this.title + ' done!');
        }
    }

    markJobOk() {

        let totalQty = this.productItems.filter((i: any) => (i.GenQty + i.RejQty) >= i.TempPlanQty);
        this.isShown = false;

        if (totalQty.length >= this.productItems.length) {
            this.isShown = true;
        }
    }


    // let totalQty = this.productItems.filter((i: any) => i.TempPlanQty - (i.GenQty  + i.RejQty) == 0);

    // if (totalQty.length ==  this.productItems.length) 
    // {
    //   this.isShown = true;
    // } 
    // else 
    // {
    //   this.isShown = false;
    // }


    //Clode Model 
    closeModal() {
        this.mdlRef.close();
    }

    getJobItems() {
        this.items = [];
        this.jobItems.forEach((a: any) => {
            if (a.StoreBatches && this.isJSON(a.StoreBatches)) {
                a.StoreBatches = JSON.parse(a.StoreBatches);
            }
            if (a.Units && this.isJSON(a.Units)) {
                a.Units = JSON.parse(a.Units);
            }
            let tmpStore = a.StoreBatches.filter(
                (s: any) => s.SID == this.frmStore.id
            );
            this.items.push({
                DoneQty: Number(a.UsedQty).toFixed(a.Units[0].Prcsn),
                MID: a.MID,
                PlanQty: Number(a.PlanQty).toFixed(a.Units[0].Prcsn),
                PQty: Number(Number(a.PlanQty).toFixed(a.Units[0].Prcsn)),
                SKU: a.SKU,
                StrQty: tmpStore.length > 0 ? Number(tmpStore[0].Q).toFixed(a.Units[0].Prcsn) : Number(0).toFixed(a.Units[0].Prcsn),
                Prcsn: a.Units[0].Prcsn,
                issueQty: '',
                ItemName: '',
                DefStockRate: 0,
                UsedQty: a.UsedQty,
                Bom: true,
                Details: a.Details || '',
            });
        });

        this.items.forEach((a: any) => {
            this.getAllItems.forEach((b: any) => {
                if (a.MID == b.ItemID) {
                    a.ItemName = b.ItemName;
                    a.DefStockRate = b.DefStockRate;
                    a.ValStdCost = b.ValStdCost;
                    a.CurrQty = b.CurrQty;
                }
            });
        });

        this.appService.updateWIPDetails(this.AllData);
        this.appService.updateItems(this.items);
    }

    prcisionCheck(obj: any) {
        obj.issueQty = this.commonService.PrecisionwiseValue(
            obj.issueQty + '',
            obj.Prcsn
        );
    }

    isJSON(str: any) {
        try {
            return JSON.parse(str) && !!str;
        } catch (e) {
            return false;
        }
    }

    //DeleteItem() - Delete Jobs
    DeleteItem(obj: any) {
        let openStage = JSON.parse(this.jobDetails[0]?.Stages).filter((stage: any) => (stage.SDT && !stage.EDT));
        let openTask = this.stageTaskDetails ? this.stageTaskDetails.filter((task: any) => task.StatusID != 3) : [];
        if (openStage.length > 0 || openTask.length > 0) {
            this.apiService.successAlert('There are unfinished stages or tasks in this project.');
            return;
        }
        this.apiService.swalConfirm("Are you sure you want to delete this " + (this.prTypeID == 1 ? 'job' : 'project') + "?", () => {
            let MyLastSyncDT = localStorage.getItem('MyLastSyncDT');

            //Validation
            if (obj == '') {
                this.apiService.successAlert('Please select ' + (this.prTypeID == 1 ? 'job' : 'project') + '.');
                return;
            }
            else {
                var tempData = [{
                    JobID: obj.id,
                }];

                let myParams = [{
                    myUserID: this.jarvisData[0].UserID,
                    myToken: this.jarvisData[0].WebToken,
                    forAgencyID: this.jarvisData[0].AgencyIDs,
                    myAgencyIDs: this.jarvisData[0].AgencyIDs,
                    myLastSyncDT: MyLastSyncDT,
                    isWeb: true,
                    ForERPAgencyID: this.MTbl[0].ERPAgencyID,
                    actionType: 'Delete',
                    moduleID: 7,
                    data: JSON.stringify(tempData),
                }];

                this.apiService.sendChange(
                    myParams,
                    this.successDelete.bind(this),
                    this.failureDelete.bind(this)
                );
            }
        });
    }

    deleteJobsItems(ind: number) {
        this.apiService.swalConfirm("Are you sure you want to delete this item from job?", () => {
            this.productItems.splice(ind, 1);

            if (this.productItems.length == 0) {
                this.apiService.successAlert("You cannot remove all items from this job.");
                return;
            }

            let generationList: any = [];
            for (let i = 0; i < this.productItems.length; i++) {
                if (this.productItems[i].PlanQty < this.productItems[i].GenQty) {
                    alert('please enter valid qty');
                    return;
                }

                let obj = {
                    ItemID: this.productItems[i].PID,
                    PlanQty: this.productItems[i].PlanQty + '',
                    DoneQty: this.productItems[i].GenQty + '',
                    XnIDs: '',
                    Description: this.productItems[i].Details || ''
                };
                generationList.push(obj);
            }

            let ConsumptionList: any = [];
            for (let i = 0; i < this.jobItems.length; i++) {
                let obj = {
                    ItemID: this.jobItems[i].MID,
                    PlanQty: this.jobItems[i].PlanQty + '',
                    DoneQty: this.jobItems[i].UsedQty + '',
                    XnIDs: '',
                    Description: this.jobItems[i].Details || ''
                };
                ConsumptionList.push(obj);
            }

            let MyLastSyncDT = localStorage.getItem('MyLastSyncDT');

            var tempData = [
                {
                    JobID: this.jobDetails[0]?.JobID,
                    TargetDT: new Date(this.jobDetails[0]?.TargetDT).customFormat("#DD#-#MMM#-#YY#"),
                    Stages: this.jobDetails[0]?.Stages,
                    Generation: JSON.stringify(generationList),
                    Consumption: JSON.stringify(ConsumptionList),
                    ChangeType: 'RMVPRD'
                },
            ];

            let myParams = [
                {
                    myUserID: this.jarvisData[0].UserID,
                    myToken: this.jarvisData[0].WebToken,
                    forAgencyID: this.jarvisData[0].AgencyIDs,
                    myAgencyIDs: this.jarvisData[0].AgencyIDs,
                    myLastSyncDT: MyLastSyncDT,
                    isWeb: true,
                    ForERPAgencyID: this.MTbl[0].ERPAgencyID,
                    actionType: 'setDetail',
                    moduleID: 7,
                    data: JSON.stringify(tempData),
                },
            ];

            // return;
            this.apiService.sendChange(
                myParams,
                this.successVchrEntry.bind(this),
                this.failureRespSave.bind(this)
            );

        });
    }

    //failureResp - failure handler
    failureDelete(res: any) {
        if (res.error) {
        } else {
            alert(res.message);
        }
    }

    //successResp - success  get handler
    successDelete(res: any) {
        if (res.error) {
        } else {
            this.apiService.removeCookie('MyLastSyncDT');
            let doneObj = {
                action: 'Done',
            };
            this.mdlRef.close(doneObj);
        }
    }

    close() {
        let doneObj = {
            action: 'Done',
        };
        this.mdlRef.close(doneObj);
    }

    editQty(obj: any) {
        obj.IsSelect = true;
        obj.tmpQty = obj.PlanQty;
    }

    cancel(obj: any) {
        obj.IsSelect = false;
        obj.PlanQty = obj.tmpQty;
    }

    save() {
        let generationList: any = [];
        for (let i = 0; i < this.productItems.length; i++) {
            if (this.productItems[i].PlanQty < this.productItems[i].GenQty) {
                alert('please enter valid qty');
                return;
            }

            let obj = {
                ItemID: this.productItems[i].PID,
                PlanQty: this.productItems[i].PlanQty + '',
                DoneQty: this.productItems[i].GenQty + '',
                XnIDs: '',
                Description: this.productItems[i].Details || ''
            };
            generationList.push(obj);
        }

        let ConsumptionList: any = [];
        for (let i = 0; i < this.jobItems.length; i++) {
            let obj = {
                ItemID: this.jobItems[i].MID,
                PlanQty: this.jobItems[i].PlanQty + '',
                DoneQty: this.jobItems[i].UsedQty + '',
                XnIDs: '',
                Description: this.jobItems[i].Details || ''
            };
            ConsumptionList.push(obj);
        }

        let MyLastSyncDT = localStorage.getItem('MyLastSyncDT');

        var tempData = [
            {
                JobID: this.jobDetails[0]?.JobID,
                TargetDT: new Date(this.jobDetails[0]?.TargetDT).customFormat("#DD#-#MMM#-#YY#"),
                Stages: this.jobDetails[0]?.Stages,
                Generation: JSON.stringify(generationList),
                Consumption: JSON.stringify(ConsumptionList),
                ChangeType: this.isTGTDT ? 'TGTDT' : 'FULL'
            },
        ];

        let myParams = [
            {
                myUserID: this.jarvisData[0].UserID,
                myToken: this.jarvisData[0].WebToken,
                forAgencyID: this.jarvisData[0].AgencyIDs,
                myAgencyIDs: this.jarvisData[0].AgencyIDs,
                myLastSyncDT: MyLastSyncDT,
                isWeb: true,
                ForERPAgencyID: this.MTbl[0].ERPAgencyID,
                actionType: 'setDetail',
                moduleID: 7,
                data: JSON.stringify(tempData),
            },
        ];

        // return;
        this.apiService.sendChange(
            myParams,
            this.successVchrEntry.bind(this),
            this.failureRespSave.bind(this)
        );
    }

    //successVchrEntry - success voucher entry handler
    successVchrEntry(res: any) {
        // this.closeModel();
        if (res.error) {
        } else {
            this.getJobDetails();
            this.isTGTDT = false;
        }
    }

    //failureResp - failure handler
    failureRespSave(res: any) {
        if (res.error) {
        } else {
            alert(res.message);
        }
        this.isTGTDT = false;
    }
    //#endregion

    openTransaction(obj: any) {

        let target: string = "_blank";
        if (this.isWeb == false) {
            target = "_self";
        }
        window.open(
            'transactionJobs;id=' + obj + ';jobID=' + this.jobDetails[0]?.JobID,
            target
        );

        let sendData = { 'prTypeID': this.prTypeID, 'costSum': this.costSum, 'jobID': this.jobDetails[0]?.JobID }
        this.appService.updateProjectData(sendData)
    }

    moveJobModal() {
        this.appService.updateMoveJobModal(1);
    }

    // markJob Done.... 
    jobCompleteSave() {
        if (confirm('Are you sure you wish to mark this ' + (this.prTypeID == 1 ? 'job' : 'project') + ' as completed?')) {
            let tempDataJobDone = [
                {
                    JobID: this.wip.id,
                    NewStatusID: 2
                },
            ];

            let myParams = [
                {
                    myUserID: this.jarvisData[0].UserID,
                    myToken: this.jarvisData[0].WebToken,
                    forAgencyID: this.jarvisData[0].AgencyIDs,
                    myAgencyIDs: this.jarvisData[0].AgencyIDs,
                    ForERPAgencyID: this.MTbl[0].ERPAgencyID,
                    myLastSyncDT: null,
                    isWeb: true,
                    actionType: 'chnageProdCompleteJob',
                    moduleID: 7,
                    data: JSON.stringify(tempDataJobDone),
                },
            ];
            this.apiService.sendChange(myParams, this.successJobDone.bind(this), this.failureRespJobDone.bind(this));
        }
    }
    //successResp - failure 
    successJobDone(res: any) {
        if (res.error) {

        } else {

        }
        this.mdlRef.close();
        this.getJobItems();
    }

    //failureResp - failure handler
    failureRespJobDone(res: any) {
        if (res.error) {
        } else {
            alert(res.message);
        }
    }
    // End markJob Done...

    goBack() {
        this.mdlRef.close('Close');
    }

    //Mobile Production Target Model open
    mobProductTarget(jobDetails: any, productItems: any) {
        this.modalReference = this.modalService.open(ProductionOutputComponent, { windowClass: 'modal-item-Edit', backdrop: 'static', keyboard: false });
        this.modalReference.componentInstance.mdlRef = this.modalReference;
        this.modalReference.componentInstance.jobDetails = jobDetails;
        this.modalReference.componentInstance.productItems = productItems;
        this.modalReference.componentInstance.prTypeID = this.prTypeID;
        // this.modalReference.componentInstance.costSum = this.costSum;
        if (this.prTypeID == 2) {
            let sendData = { 'prTypeID': this.prTypeID, 'costSum': this.costSum, 'jobID': this.jobDetails[0]?.JobID }
            this.appService.updateProjectData(sendData)
        }

        this.modalReference.result.then((result: any) => {
            this.closeResult = `Closed with: ${result}`;
        }, (reason: any) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
    }

    // Mobile Material Consumption Modal Open
    mobMaterialCons() {
        this.modalReference = this.modalService.open(MaterialConsumptionComponent, { windowClass: 'item-Edit-BOM', backdrop: 'static', keyboard: false });
        this.modalReference.componentInstance.mdlRef = this.modalReference;
        this.modalReference.componentInstance.prTypeID = this.prTypeID;
        this.modalReference.result.then((result: any) => {
            this.closeResult = `Closed with: ${result}`;
        }, (reason: any) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
    }

    // Mobile Process Stages Modal 
    mobProcessStages() {
        this.modalReference = this.modalService.open(ProcessStagesComponent, { windowClass: 'item-Edit-Stage', backdrop: 'static', keyboard: false });
        this.modalReference.componentInstance.mdlRef = this.modalReference;
        this.modalReference.componentInstance.prTypeID = this.prTypeID;
        this.getJobItems();
        this.modalReference.result.then((result: any) => {
            if (result == true) {
            }
            this.closeResult = `Closed with: ${result}`;
        }, (reason: any) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
    }


    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        }
    }

    //editDate - change date
    editDate(date: any) {
        this.isDateLableShow = false;
        this.jobDetails[0].TargetDT = new Date(date);
    }

    //saveNewDate() - save after change date
    saveNewDate() {
        this.jobDetails[0].TargetDT = new Date(this.jobDetails[0]?.TargetDT).customFormat("#DD#-#MMM#-#YY#");
        this.isDateLableShow = true;
        this.isTGTDT = true;
        this.save();
    }
    selectUser(): void {
        if (this.selectedUserID == 0) {
            this.apiService.successAlert('Please select a valid executive.');
            return;
        }

        const user = this.userList.find((user: any) => user.UserID == this.selectedUserID);
        if (user) {
            user.selected = true;
            this.users.push(user);
        }
        this.selectedUserID = 0;
    }
    removeUser(index: number): void {
        const user = this.users[index];
        this.userList.forEach((u: any) => {
            if (user.UserID == u.UserID) {
                u.selected = false;
            }
        });
        this.users.splice(index, 1);
        this.selectedUserID = 0;
    }
    openUserAccessModal(content: any) {

        this.modalReference = this.modalService.open(content, { windowClass: "openStageModal", ariaLabelledBy: 'modal-basic-title', backdrop: 'static', keyboard: false });
    }
    closeUserAccessModal() {
        this.users = [...this.dbUsers];
        this.userList.forEach((user: any) => {
            if (this.users.includes(user)) {
                user.selected = true;
            }
            else {
                user.selected = false;
            }
        })
        this.modalReference.close();
    }
    updateUserAccess() {

        let generationList: any = [];
        for (let i = 0; i < this.productItems.length; i++) {
            if (this.productItems[i].PlanQty < this.productItems[i].GenQty) {
                alert('please enter valid qty');
                return;
            }

            let obj = {
                ItemID: this.productItems[i].PID,
                PlanQty: this.productItems[i].PlanQty + '',
                DoneQty: this.productItems[i].GenQty + '',
                XnIDs: '',
                Description: this.productItems[i].Details || ''
            };
            generationList.push(obj);
        }

        let ConsumptionList: any = [];
        for (let i = 0; i < this.jobItems.length; i++) {
            let obj = {
                ItemID: this.jobItems[i].MID,
                PlanQty: this.jobItems[i].PlanQty + '',
                DoneQty: this.jobItems[i].UsedQty + '',
                XnIDs: '',
                Description: this.jobItems[i].Details || ''
            };
            ConsumptionList.push(obj);
        }
        let MyLastSyncDT = localStorage.getItem("MyLastSyncDT");
        let userIDs = '';
        if (this.prTypeID == 2) {
            let adminUser = this.users.find((user: any) => user.UserID == this.agencyData[0].AdminUserID);
            if (!adminUser) {
                adminUser = this.userList.find((user: any) => user.UserID == this.agencyData[0].AdminUserID);
                adminUser.selected = true;
                this.users.push(adminUser);
            }
            let currUser = this.users.find((user: any) => user.UserID == this.jarvisData[0].UserID);
            if (!currUser) {
                currUser = this.userList.find((user: any) => user.UserID == this.jarvisData[0].UserID);
                currUser.selected = true;
                this.users.push(currUser);
            }
            userIDs = [...new Set(this.users.map(user => user.UserID))].join(',');
        }
        var tempData = [
            {
                'JobID': this.jobDetails[0]?.JobID,
                'TargetDT': new Date(),
                'Stages': this.jobDetails[0]?.Stages,
                'Generation': JSON.stringify(generationList),
                'Consumption': JSON.stringify(ConsumptionList),
                'ChangeType': 'PROJUSRUPDT',
                'UserIDs': userIDs,
                'prdTypeID': this.prTypeID
            }
        ];

        let myParams = [
            {
                myUserID: this.jarvisData[0].UserID,
                myToken: this.jarvisData[0].WebToken,
                forAgencyID: this.jarvisData[0].AgencyIDs,
                myAgencyIDs: this.jarvisData[0].AgencyIDs,
                myLastSyncDT: MyLastSyncDT,
                isWeb: true,
                ForERPAgencyID: this.agencyData[0].ERPAgencyID,
                actionType: 'setDetail',
                moduleID: 7,
                data: JSON.stringify(tempData),
            },
        ];
        this.apiService.sendChange(myParams, this.successNewStageEntry.bind(this), this.failureNewStageResp.bind(this));
    }

    successNewStageEntry(res: any) {
        if (res.error) {
        }
        else {
            if (res) {
                this.apiService.successAlert("User access updated successfullly.");
                this.getJobDetails();
            }
            this.modalReference.close();
        }
    }
    failureNewStageResp(res: any) {
        if (res.error) {
        }
        else {
            alert(res.message);
        }
    }
    //#endregion
    public processEventFromMtlCons($event: any) {
        this.showMtlConsExpanded = $event;
        /*this.modalReference.close();
        if ($event) {
          this.changingValue.next($event);
          this.changingHeadValue.next($event);
        }*/
    }

    //viewFile() - View attached file
    viewFile() {
        if (this.jobDetails[0]?.Attachment && this.jobDetails[0]?.Attachment != '') {
            const strAgn = this.MTbl[0].ERPAgencyID.toString().padStart(10, '0');
            const biziFilesURL = this.apiService.getBiziFilesURL();

            let fileURL = `${biziFilesURL}Files/${strAgn}/Jobs/${this.jobDetails[0]?.Attachment}`;

            if (this.isWeb) {
                // Open in popup window for web
                const windowFeatures = 'width=1000,height=700,scrollbars=yes,resizable=yes,toolbar=no,menubar=no,location=no,status=no';
                window.open(fileURL, 'DescriptorFile', windowFeatures);
            } else {
                // Open in same window for mobile app
                window.location.href = fileURL;
            }
        }
    }

}

